import { cx } from './cx'
import styles from './Toggle.module.css'

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  /** Accessible name (required: the switch has no visible text of its own). */
  'aria-label': string
  /** Locked toggles keep their state and can't be changed. */
  disabled?: boolean
}

/** Switch matching conds `DsToggle`: 150ms slide, knob shadow from tokens. */
export function Toggle({ checked, onChange, disabled, 'aria-label': ariaLabel }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={cx(styles.track, checked && styles.on)}
      onClick={() => onChange(!checked)}
    >
      <span className={styles.knob} />
    </button>
  )
}
